import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/OfferManagement";

class OfferService {
    create(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(params, page) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                ...params,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(offerId, data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${offerId}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(offerId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${offerId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(offerId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${offerId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewOfferService = new OfferService();
export default NewOfferService;